export interface PointOfDelivery {
  pointOfDeliveryCode: string;
  pointOfDeliveryDesc: string;
  pointOfDeliveryId: number;
}
